import restaurantOffers from "./restaurantOffers";
export default{
    ...restaurantOffers,

};